// アプリ全体を包む Error Boundary。React ツリーがクラッシュしたときに
// 白画面ではなく localize した復帰 UI を出し、例外を Sentry に送る。
//
// - Sentry.ErrorBoundary を薄くラップしただけ。Sentry 未初期化でも fallback は動く
//   （Sentry.ErrorBoundary は init 有無に関わらずキャッチ + fallback 表示する）。
// - 文言は i18n dict（Inertia shared props の props.i18n）を受け取り createT で解決する。
//   エントリポイントは props 解決前に描画されないため dict は常に渡せる。
import * as Sentry from "@sentry/react";
import { createT, type LocaleDict } from "@/lib/i18n";

type Props = {
  i18n: LocaleDict;
  children: React.ReactNode;
};

export default function SentryErrorBoundary({ i18n, children }: Props) {
  const t = createT(i18n);

  return (
    <Sentry.ErrorBoundary
      fallback={
        <div
          role="alert"
          className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center"
        >
          <h1 className="text-xl font-semibold text-slate-900">
            {t("errors.boundary.title")}
          </h1>
          <p className="max-w-md text-sm text-slate-600">
            {t("errors.boundary.description")}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700"
          >
            {t("errors.boundary.reload")}
          </button>
        </div>
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
